import { Namespace, TFunction } from 'i18next';
import { ConfirmationModalOptions, EntityInfo } from './types';
import { I18nKey } from '@/utils/typings';

export function getDefaultOptions(t: TFunction<Namespace, undefined>): ConfirmationModalOptions {
  return {
    title: t('Confirmation'),
    text: t('ChangesWontBeSavedMsg'),
    confirmButton: t('Leave'),
    confirmationButtonType: 'Leave',
    cancelButton: t('Stay'),
    size: 'medium',
    hideClose: true,
  };
}

export function getDefaultDeleteConfirmationOptions(
  entityData: EntityInfo,
  t: TFunction<Namespace, undefined>,
) {
  return {
    title: t('Confirmation'),
    text: '',
    contentData: {
      type: 'normal',
      entityData,
      confirmation: t('DeleteEntityConfirmationMsg', {
        entityName: t(entityData.typeName as I18nKey),
      }),
      hint: t('DeleteEntityConfirmationHint'),
    },
    confirmButton: t('Delete'),
    cancelButton: t('Cancel'),
    confirmationButtonType: 'Delete',
    hideClose: false,
    size: 'medium',
  } satisfies ConfirmationModalOptions;
}
